import React, {useCallback} from 'react';
import Landmark from '@core/scripts/components/landmark-adapter';
import {Breadcrumb as DesyBreadcrumb, Typography} from '@bonprix/design-system';

const Breadcrumb = React.memo(({breadcrumbs}) => {
    const handleClick = useCallback((landmark) => {
        if (landmark) {
            Landmark.sendClickLandmark(landmark);
        }
    }, []);

    const previous = breadcrumbs.previous;
    const current = breadcrumbs.current;
    return (
        <div className="article-overview-breadcrumb">
            {previous && (
                <div className="article-overview-breadcrumb-container" onClick={() => handleClick(previous.landmark)}>
                    <DesyBreadcrumb
                        hideHeader={true}
                        currentPageTitle={current?.name || ''}
                        previousPageTitle={previous.name}
                        previousPageUrl={previous.url}
                    />
                </div>
            )}
            {current && (
                <div className="article-overview-breadcrumb-headline-container">
                    <div className="article-overview-breadcrumb-name-container">
                        <Typography component={'h1'} variant="bonprix-h3">
                            {current.name}
                        </Typography>
                    </div>
                    <p className="typography-body1 article-overview-breadcrumb-hit-count">
                        {breadcrumbs.hits} {breadcrumbs.texts.breadcrumb_article}
                    </p>
                </div>
            )}
        </div>
    );
});

export default Breadcrumb;
